import React, { useState, useEffect } from "react";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Icon from "@amzn/meridian/icon";
import sparklesSmallTokens from "@amzn/meridian-tokens/base/icon/sparkles-small";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronUpSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-up-small";
import ReactMarkdown from "react-markdown";
import styles from "./AIChatModal.module.scss";

interface ThinkingSectionProps {
    thinking: string;
    isStreaming?: boolean;
}

export const ThinkingSection: React.FC<ThinkingSectionProps> = ({
    thinking,
    isStreaming = false,
}) => {
    const [isExpanded, setIsExpanded] = useState(isStreaming);

    // Auto-expand when streaming starts
    useEffect(() => {
        if (isStreaming) {
            setIsExpanded(true);
        }
    }, [isStreaming]);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Box className={styles.thinkingContainer}>
            {/* Header - Always visible, clickable to expand/collapse */}
            <div className={styles.thinkingHeader} onClick={toggleExpanded}>
                <Row spacing="200" alignmentVertical="center">
                    <Box className={styles.thinkingIcon}>
                        <Icon tokens={sparklesSmallTokens} />
                    </Box>
                    <Text type="b300" className={styles.thinkingLabel}>
                        Thinking
                        {isStreaming && <span className={styles.streamingIndicator}> ●●●</span>}
                    </Text>
                    <Box className={styles.chevronIcon}>
                        <Icon tokens={isExpanded ? chevronUpSmallTokens : chevronDownSmallTokens} />
                    </Box>
                </Row>
            </div>

            {/* Content - Conditionally rendered when expanded */}
            {isExpanded && (
                <Box className={styles.thinkingContent}>
                    <div className={styles.thinkingText}>
                        <ReactMarkdown>{thinking}</ReactMarkdown>
                    </div>
                </Box>
            )}
        </Box>
    );
};
